import {
  MessageContext,
  OnboardingMessageType,
  type OnboardingMessage,
} from "@/lib/api/onboarding-messages";

// Keep in sync with DEFAULT_ONLINE_MESSAGE / DEFAULT_OFFLINE_MESSAGE in
// somethings-api src/services/onboarding-messages.ts. The API sends these
// when a mentor has no saved text messages for that context.
export const DEFAULT_ONLINE_ONBOARDING_MESSAGE =
  "Heyy I'm so excited you're here!! It looks like we got a lot in common and I'm excited to get into it 💛 but first, how's ur day been?";

export const DEFAULT_OFFLINE_ONBOARDING_MESSAGE =
  "heyy so excited to start chatting! this is just my automated msg since i'm back online at 5 PM :') when i'm on i'll send a quick message so u know i'm real haha";

export function textOnboardingMessages(
  messages: OnboardingMessage[] | undefined,
): OnboardingMessage[] {
  return (messages ?? []).filter(
    (message) => message.type === OnboardingMessageType.TEXT,
  );
}

export function onboardingMessagesForDisplay(
  messages: OnboardingMessage[] | undefined,
  context: MessageContext,
): { messages: OnboardingMessage[]; usingDefault: boolean } {
  const saved = textOnboardingMessages(messages);
  if (messages === undefined || saved.length > 0) {
    return { messages: saved, usingDefault: false };
  }

  const message =
    context === MessageContext.OFFLINE
      ? DEFAULT_OFFLINE_ONBOARDING_MESSAGE
      : DEFAULT_ONLINE_ONBOARDING_MESSAGE;

  return {
    usingDefault: true,
    messages: [
      {
        id: `default-${context}`,
        message,
        type: OnboardingMessageType.TEXT,
        message_context: context,
        metadata: {},
        created_at: "",
        updated_at: "",
        position: 0,
      },
    ],
  };
}

export function formatMessageCount(count: number): string {
  return count === 1 ? "1 message" : `${count} messages`;
}

export function formatStorySummary(slideCount: number): string {
  if (slideCount === 0) {
    return "Not recorded";
  }
  return slideCount === 1 ? "1 slide" : `${slideCount} slides`;
}
